let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("fCOeQ")).then(() => parcelRequire('ctb0H'));